export function IconProvider() {
    return (
        <svg aria-hidden="true" style={{ display: 'none' }}>

            <symbol id="bjnt-icon-play" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
            </symbol>

            <symbol id="bjnt-icon-home" viewBox="0 0 24 24">
                <path d="M3 10.8 12 3l9 7.8v10.2h-6v-6h-6v6H3z" />
            </symbol>

            <symbol id="bjnt-icon-search" viewBox="0 0 24 24">
                <path d="M10.5 4a6.5 6.5 0 0 1 5.17 10.44l4.45 4.44-1.42 1.42-4.44-4.45A6.5 6.5 0 1 1 10.5 4Zm0 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z" />
            </symbol>

            <symbol id="bjnt-icon-upload" viewBox="0 0 24 24">
                <path d="M12 3 6.5 8.5l1.4 1.4L11 6.8V16h2V6.8l3.1 3.1 1.4-1.4L12 3Z" />
                <path d="M5 18h14v2H5z" />
            </symbol>

            <symbol id="bjnt-icon-share" viewBox="0 0 24 24">
                <path d="M18 16.1c-.76 0-1.44.3-1.96.77L8.91 12.7c.06-.23.09-.46.09-.7s-.03-.47-.09-.7l7.05-4.11A3 3 0 1 0 15 5c0 .24.03.47.09.7L8.04 9.81A3 3 0 1 0 8.04 14.2l7.12 4.18c-.04.2-.06.41-.06.62a2.9 2.9 0 1 0 2.9-2.9Z" />
            </symbol>

            <symbol id="bjnt-icon-arrow-left" viewBox="0 0 24 24">
                <path d="M11 5 4 12l7 7 1.4-1.4L7.8 13H20v-2H7.8l4.6-4.6L11 5Z" />
            </symbol>

            <symbol id="bjnt-icon-arrow-right" viewBox="0 0 24 24">
                <path d="M13 5l7 7-7 7-1.4-1.4 4.6-4.6H4v-2h12.2l-4.6-4.6L13 5Z" />
            </symbol>

            <symbol id="bjnt-icon-prev" viewBox="0 0 24 24">
                <path d="M6 5h2v14H6z" />
                <path d="M18 6v12l-8-6z" />
            </symbol>

            <symbol id="bjnt-icon-next" viewBox="0 0 24 24">
                <path d="M16 5h2v14h-2z" />
                <path d="M6 6v12l8-6z" />
            </symbol>

            <symbol id="bjnt-icon-pause" viewBox="0 0 24 24">
                <path d="M6 5h4v14H6z" />
                <path d="M14 5h4v14h-4z" />
            </symbol>
            <symbol id="bjnt-icon-share-2" viewBox="0 0 24 24">
                <path d="M12 3l4 4-1.4 1.4L13 6.8V15h-2V6.8L9.4 8.4 8 7l4-4z" />
                <path d="M5 11v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h-2v6H7v-6H5z" />
            </symbol>
            <symbol id="bjnt-icon-whatsapp" viewBox="0 0 32 32">
                <path xmlns="http://www.w3.org/2000/svg" d="M17,0C8.7,0,2,6.7,2,15c0,3.4,1.1,6.6,3.2,9.2l-2.1,6.4c-0.1,0.4,0,0.8,0.3,1.1C3.5,31.9,3.8,32,4,32c0.1,0,0.3,0,0.4-0.1  l6.9-3.1C13.1,29.6,15,30,17,30c8.3,0,15-6.7,15-15S25.3,0,17,0z M25.7,20.5c-0.4,1.2-1.9,2.2-3.2,2.4C22.2,23,21.9,23,21.5,23  c-0.8,0-2-0.2-4.1-1.1c-2.4-1-4.8-3.1-6.7-5.8L10.7,16C10.1,15.1,9,13.4,9,11.6c0-2.2,1.1-3.3,1.5-3.8c0.5-0.5,1.2-0.8,2-0.8  c0.2,0,0.3,0,0.5,0c0.7,0,1.2,0.2,1.7,1.2l0.4,0.8c0.3,0.8,0.7,1.7,0.8,1.8c0.3,0.6,0.3,1.1,0,1.6c-0.1,0.3-0.3,0.5-0.5,0.7  c-0.1,0.2-0.2,0.3-0.3,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.9,1.4,1.7,2.1c1.2,1.1,2.1,1.4,2.6,1.6l0,0c0.2-0.2,0.4-0.6,0.7-0.9  l0.1-0.2c0.5-0.7,1.3-0.9,2.1-0.6c0.4,0.2,2.6,1.2,2.6,1.2l0.2,0.1c0.3,0.2,0.7,0.3,0.9,0.7C26.2,18.5,25.9,19.8,25.7,20.5z" />
            </symbol>

            <symbol id="bjnt-icon-facebook" viewBox="0 0 24 24">
                <path d="M13 22v-8h3l1-4h-4V8c0-1.2.3-2 2-2h2V2.5c-.3 0-1.4-.1-2.7-.1C11.6 2.4 10 4 10 7v3H7v4h3v8z" />
            </symbol>

            <symbol id="bjnt-icon-x" viewBox="0 0 24 24">
                <path d="M18.2 3H21l-6.1 7 7.1 11h-5.6l-4.4-6.9L5.9 21H3l6.5-7.5L2.7 3h5.7l4 6.3L18.2 3z" />
            </symbol>

            <symbol id="bjnt-icon-link" viewBox="0 0 24 24">
                <path d="M10 14a1 1 0 0 1 0-2h4a1 1 0 1 1 0 2h-4z" />
                <path d="M7.5 17A4.5 4.5 0 0 1 7.5 8H10a1 1 0 1 1 0 2H7.5a2.5 2.5 0 0 0 0 5H10a1 1 0 1 1 0 2H7.5z" />
                <path d="M14 17a1 1 0 1 1 0-2h2.5a2.5 2.5 0 0 0 0-5H14a1 1 0 1 1 0-2h2.5a4.5 4.5 0 0 1 0 9H14z" />
            </symbol>
        </svg>
    );
}

export function Icon({ name, size = 18 }) {
    return (
        <svg
            className="bjnt-icon"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
        >
            <use href={`#bjnt-icon-${name}`} />

            <symbol id="bjnt-icon-cast" viewBox="0 0 24 24">
                <path d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-4v-2h4V6H5v1H3V6z" />
                <path d="M3 10v2a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8z" />
                <path d="M3 14v2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4z" />
                <path d="M3 18h2v2H3z" />
            </symbol>

            <symbol id="bjnt-icon-airplay" viewBox="0 0 24 24">
                <path d="M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3v-2h3V7H5v8h3v2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" />
                <path d="M12 13 7 20h10l-5-7z" />
            </symbol>
        </svg>
    );
}